import { atom } from 'recoil';

export const sheetFabState = atom({
  key: 'sheetFabState',
  default: false,
});
